import { lazy } from 'react';
var QuizConsumption = lazy(function () {
    return import(/* webpackChunkName: "quizConsumption" */ './components').then(function (_a) {
        var QuizConsumption = _a.QuizConsumption;
        return ({
            default: QuizConsumption,
        });
    });
});
export default QuizConsumption;
